/* DYEGUYS custom sections — menu, carousel, video pop-up, variant picker */
(function () {
  if (window.__dgInit) return;
  window.__dgInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* ---------- Mobile menu + dropdowns ----------
     Uses delegated listeners so it keeps working after the theme
     re-renders the header (for example after adding to cart). */
  var lastMenuButton = null;

  function openMenu(btn) {
    var drawer = document.getElementById(btn.getAttribute('aria-controls'));
    if (!drawer) return;
    lastMenuButton = btn;
    drawer.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('dg-lock');
    var closeBtn = drawer.querySelector('.dg-drawer__close');
    if (closeBtn) closeBtn.focus();
  }
  function closeMenu(drawer) {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('dg-lock');
    var btn = document.querySelector('[data-dg-menu-toggle][aria-controls="' + drawer.id + '"]');
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    } else if (lastMenuButton) {
      lastMenuButton.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-dg-menu-toggle]');
    if (toggle) { openMenu(toggle); return; }

    var closer = e.target.closest('[data-dg-menu-close]');
    if (closer) { closeMenu(closer.closest('.dg-drawer')); return; }

    // Close open desktop dropdowns when clicking elsewhere
    document.querySelectorAll('[data-dg-dropdown][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var drawer = document.querySelector('.dg-drawer:not([hidden])');
    if (drawer) { closeMenu(drawer); return; }
    var open = document.querySelector('[data-dg-dropdown][open]');
    if (open) {
      open.open = false;
      var summary = open.querySelector('summary');
      if (summary) summary.focus();
    }
  });

  /* ---------- Shop grid sort menu ---------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-dg-sort]');
    if (select && select.form) select.form.submit();
  });

  /* ---------- Header height (used by sticky elements) ---------- */
  function trackHeaderHeight() {
    if (window.__dgHeaderObserved || !window.ResizeObserver) return;
    var header = document.querySelector('.dg-header');
    if (!header) return;
    window.__dgHeaderObserved = true;
    function set() {
      var el = document.querySelector('.dg-header');
      if (!el) return;
      var h = el.classList.contains('dg-header--sticky') ? el.offsetHeight : 0;
      document.body.style.setProperty('--dg-sticky-offset', h + 'px');
      document.body.style.setProperty('--header-height', h + 'px');
    }
    new ResizeObserver(set).observe(header);
    set();
  }

  /* ---------- Add to cart through the theme's cart drawer ----------
     When the theme cart drawer is on the page, our product forms add
     items in place and open the drawer. Otherwise they post normally
     and Shopify shows the cart page. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('.dg-pdp__form, .dg-feature__form')) return;

    var button = form.querySelector('[data-dg-add]');
    if (button && button.disabled) { e.preventDefault(); return; }

    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || !window.fetch || !window.FormData) return;

    e.preventDefault();
    var errorEl = form.querySelector('[data-dg-cart-error]');
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    var data = new FormData(form);
    var sectionIds = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId && sectionIds.indexOf(el.dataset.sectionId) === -1) sectionIds.push(el.dataset.sectionId);
    });
    if (sectionIds.length) {
      data.append('sections', sectionIds.join(','));
      data.append('sections_url', window.location.pathname);
    }

    var url = (window.Theme && Theme.routes && Theme.routes.cart_add_url) ||
      (((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js');

    if (button) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }

    fetch(url, {
      method: 'POST',
      body: data,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, json: json }; });
      })
      .then(function (result) {
        var json = result.json || {};
        if (!result.ok || json.status) {
          if (errorEl) {
            errorEl.textContent = json.description || json.message || 'Something went wrong. Please try again.';
            errorEl.hidden = false;
          }
          return;
        }
        var id = String(data.get('id') || '');
        form.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: {},
            sourceId: id,
            data: {
              source: 'product-form-component',
              itemCount: Number(data.get('quantity')) || 1,
              variantId: id,
              sections: json.sections,
            },
          },
        }));
        if (typeof drawer.open === 'function') drawer.open();
      })
      .catch(function () {
        // Network or parsing problem: fall back to a normal form post
        form.submit();
      })
      .then(function () {
        if (!button) return;
        button.removeAttribute('aria-busy');
        button.disabled = false;
      });
  });

  /* ---------- Product carousel ---------- */
  function initRails(root) {
    root.querySelectorAll('[data-dg-rail-wrap]').forEach(function (wrap) {
      if (!once(wrap, 'dgBound')) return;
      var rail = wrap.querySelector('[data-dg-rail]');
      var prev = wrap.querySelector('[data-dg-prev]');
      var next = wrap.querySelector('[data-dg-next]');
      if (!rail || !prev || !next) return;

      function step() {
        return Math.max(rail.clientWidth * 0.9, 200);
      }
      function go(dir) {
        rail.scrollBy({ left: dir * step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      function update() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
      }

      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      rail.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Video pop-up ---------- */
  function initVideos(root) {
    root.querySelectorAll('[data-dg-video-open]').forEach(function (btn) {
      if (!once(btn, 'dgBound')) return;
      var dialog = document.getElementById(btn.getAttribute('aria-controls'));
      if (!dialog || typeof dialog.showModal !== 'function') return;
      var frame = dialog.querySelector('iframe');

      btn.addEventListener('click', function () {
        if (frame && frame.dataset.src) frame.src = frame.dataset.src;
        dialog.showModal();
      });
      dialog.addEventListener('close', function () {
        if (frame) frame.removeAttribute('src');
        btn.focus();
      });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) dialog.close();
      });
      var closeBtn = dialog.querySelector('[data-dg-video-close]');
      if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
    });
  }

  /* ---------- Variant picker (featured product) ---------- */
  function initVariants(root) {
    root.querySelectorAll('[data-dg-variant-select]').forEach(function (select) {
      if (!once(select, 'dgBound')) return;
      var form = select.closest('form');
      if (!form) return;
      var price = form.querySelector('[data-dg-price]');
      var compare = form.querySelector('[data-dg-compare]');
      var button = form.querySelector('[data-dg-add]');
      var label = button ? button.querySelector('[data-dg-add-label]') : null;

      select.addEventListener('change', function () {
        var opt = select.selectedOptions[0];
        if (!opt) return;
        if (price) price.textContent = opt.dataset.price || '';
        if (compare) compare.textContent = opt.dataset.compare || '';
        if (button) {
          var available = opt.dataset.available === 'true';
          button.disabled = !available;
          if (label) label.textContent = available ? button.dataset.labelAdd : button.dataset.labelSold;
        }
      });
    });
  }


  /* ---------- Product gallery ---------- */
  function initGalleries(root) {
    root.querySelectorAll('[data-dg-gallery]').forEach(function (gallery) {
      if (!once(gallery, 'dgBound')) return;
      var track = gallery.querySelector('[data-dg-gallery-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var thumbs = gallery.querySelectorAll('[data-dg-thumb]');
      var prev = gallery.querySelector('[data-dg-gallery-prev]');
      var next = gallery.querySelector('[data-dg-gallery-next]');
      var counter = gallery.querySelector('[data-dg-gallery-index]');

      function current() {
        return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      }
      function goTo(i, instant) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
      }
      function update() {
        var i = current();
        thumbs.forEach(function (t, n) {
          if (n === i) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
        if (counter) counter.textContent = String(i + 1);
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= slides.length - 1;
      }

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(Number(t.dataset.dgThumb)); });
      });
      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
      });
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; update(); });
      }, { passive: true });

      gallery.dgShowMedia = function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].dataset.mediaId === String(mediaId)) { goTo(i); return; }
        }
      };

      // Open on the selected variant's photo (e.g. links with ?variant=)
      var start = gallery.dataset.startMedia;
      if (start && slides[0] && slides[0].dataset.mediaId !== start) {
        for (var k = 0; k < slides.length; k++) {
          if (slides[k].dataset.mediaId === start) { goTo(k, true); break; }
        }
      }
      update();
    });
  }

  /* ---------- Product page options ---------- */
  function initProducts(root) {
    root.querySelectorAll('[data-dg-product]').forEach(function (el) {
      if (!once(el, 'dgBound')) return;
      var dataEl = el.querySelector('[data-dg-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var form = el.querySelector('form');
      var idInput = el.querySelector('[data-dg-variant-id]');
      var price = el.querySelector('[data-dg-price]');
      var compare = el.querySelector('[data-dg-compare]');
      var button = el.querySelector('[data-dg-add]');
      var label = button ? button.querySelector('[data-dg-add-label]') : null;
      var badge = el.querySelector('[data-dg-soldout-badge]');
      var gallery = el.querySelector('[data-dg-gallery]');
      var inputs = Array.prototype.slice.call(el.querySelectorAll('[data-dg-option]'));
      var optionCount = inputs.reduce(function (max, i) { return Math.max(max, Number(i.dataset.dgOption) + 1); }, 0);

      function selected() {
        var values = [];
        for (var n = 0; n < optionCount; n++) {
          var checked = el.querySelector('[data-dg-option="' + n + '"]:checked');
          values.push(checked ? checked.value : null);
        }
        return values;
      }
      function find(values) {
        return variants.find(function (v) {
          return values.every(function (val, n) { return v.options[n] === val; });
        });
      }
      function markAvailability(values) {
        inputs.forEach(function (input) {
          var n = Number(input.dataset.dgOption);
          var test = values.slice();
          test[n] = input.value;
          var match = find(test);
          var pill = input.nextElementSibling;
          if (pill) pill.classList.toggle('is-unavailable', !match || !match.available);
        });
      }
      function setButton(state) {
        if (!button) return;
        button.disabled = state !== 'add';
        if (label) {
          label.textContent = state === 'add' ? button.dataset.labelAdd
            : state === 'sold' ? button.dataset.labelSold
            : button.dataset.labelNone;
        }
      }
      function onChange() {
        var values = selected();
        values.forEach(function (val, n) {
          var out = el.querySelector('[data-dg-option-value="' + n + '"]');
          if (out) out.textContent = val || '';
        });
        markAvailability(values);
        var v = find(values);
        if (!v) { setButton('none'); return; }
        if (idInput) idInput.value = v.id;
        if (price) price.textContent = v.price;
        if (compare) compare.textContent = v.compare || '';
        if (badge) badge.hidden = v.available;
        setButton(v.available ? 'add' : 'sold');
        if (v.media && gallery && gallery.dgShowMedia) gallery.dgShowMedia(v.media);
        if (el.dataset.url && window.history && history.replaceState) {
          history.replaceState(null, '', el.dataset.url + '?variant=' + v.id);
        }
      }

      inputs.forEach(function (i) { i.addEventListener('change', onChange); });
      if (inputs.length) markAvailability(selected());

      // Quantity stepper
      var qty = el.querySelector('.dg-qty__input');
      el.querySelectorAll('[data-dg-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qty) return;
          var val = (parseInt(qty.value, 10) || 1) + Number(btn.dataset.dgQty);
          qty.value = Math.max(1, val);
        });
      });

      if (form) {
        form.addEventListener('submit', function (e) {
          if (button && button.disabled) e.preventDefault();
        });
      }
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations(root) {
    root.querySelectorAll('[data-dg-recs]').forEach(function (box) {
      if (!once(box, 'dgBound')) return;
      if (box.querySelector('[data-dg-rail]') || !box.dataset.url || !window.fetch) return;
      fetch(box.dataset.url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-dg-recs]');
          if (!fresh || !fresh.querySelector('[data-dg-rail]')) return;
          box.innerHTML = fresh.innerHTML;
          box.hidden = false;
          initRails(box);
        })
        .catch(function () {});
    });
  }

  function initAll(root) {
    root = root || document;
    trackHeaderHeight();
    initRails(root);
    initVideos(root);
    initVariants(root);
    initGalleries(root);
    initProducts(root);
    initRecommendations(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Re-run when sections change inside the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function () {
    document.documentElement.classList.remove('dg-lock');
  });
})();
